import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import AiDispatcherActivity from '@components/features/ai-dispatcher/observability/AiDispatcherActivity';

interface ComponentProps {}

/**
 * The same activity screens a company user gets, for the company whose row the admin opened.
 *
 * Push does not reach here — the connection token carries the logged-in user's own company — so
 * this falls back to polling, which is exactly why polling is the baseline and not the fallback.
 */
const AdminAiDispatcherActivityPage: React.FC<ComponentProps> = () => {
  const { companyId } = useParams();

  if (!companyId) {
    return <></>;
  }

  return (
    <>
      <AdminLayout title={'AI dispatcher activity'}>
        <AiDispatcherActivity companyId={companyId} />
      </AdminLayout>
    </>
  );
};

export default withAuthenticationRequired(AdminAiDispatcherActivityPage);
